module.exports = __webpack_public_path__ + "img/roadheaders.b4982623.jpg";